// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cb8fd5e7","239":"34237ca5","455":"ac2c9d3f"}[chunkId] + ".chunk.js";
};